import { Container, Copyright } from './styles';

function Footer() {
  return (
    <Container>
      <Copyright>Copyright© Zona Sul 1996 - 2020 Super Mercado Zona Sul S/A F1129 - CNPJ: 33.381.286/0023-67 - Endereço: Rua Comandante Vergueiro da Cruz, 380 - Olaria - Rio de Janeiro - RJ - CEP: 21021-020</Copyright>
    </Container>
  );
}

export default Footer;
